import { useEffect, useState } from "react";
import { Box, Button, Dialog, Divider, MenuItem, Select, TextField, Typography } from "@mui/material";
import * as Icon from "@mui/icons-material";
import PackageCard from "../PackageCard";
import { empty, extractDataFromArray, getActivityType } from "../../utils/common";
import { useLoaderData, useLocation, useNavigate } from "react-router";
import { ROUTE_CREATE_ACCESS_PACKAGE } from "../../constants/page";
import GreyLabel from "../formElement/GreyLabel";
import PackageService from "../../services/package";
import config from "../../config";

const packageOrder = [
    {
        type: 'H',
        label: 'Hunting'
    },
    {
        type: 'F',
        label: 'Fishing'
    },
    {
        type: 'BW',
        label: 'Bird Watching'
    },
    {
        type: 'FR',
        label: 'Farm and Ranch'
    },
    {
        type: 'C',
        label: 'Camping'
    },
    {
        type: 'O',
        label: 'Others'
    },
];

const PackageList = ({ sectionRef, packages, listingData, ...props }) => {
    const [packageActivity, setPackageActivty] = useState('A')
    const [packageGroupedCount, setPackageGroupedCount] = useState({})
    const [packageGrouped, setPackageGrouped] = useState({})
    const [isPropertyPage, setIsPropertyPage] = useState(false)
    const [confirmationPopup, setConfirmationPopup] = useState({ open: false, })



    const location = useLocation();
    const navigate = useNavigate()


    const filterPackages = (setFuntion) => {
        let temp = {}
        packages.forEach(packageData => {
            if (packageActivity !== 'A') {
                if (packageData.activity_type !== packageActivity) {
                    return
                }
            }
            if (typeof temp[packageData.activity_type] === "undefined") {
                temp[packageData.activity_type] = [];
            }
            temp[packageData.activity_type].push(packageData)
        })
        setFuntion(temp)
    }

    const openChangeStatusConfirmation = (package_seq, status) => {
        setConfirmationPopup({
            open: true,
            package_seq: package_seq,
            status: status,
            title: 'Confirm the action',
            body: <Typography>Do you really want to {status !== 'I' ? "move this package to draft?" : "publish this package?"} </Typography>,
            buttons:
                <>
                    <Button variant="text" color="secondary" onClick={() => { setConfirmationPopup({ open: false }) }}>CANCEL</Button>
                    <Button variant="contained" color="primary" onClick={() => { updatePackageStatus(status, package_seq) }}>{status !== 'I' ? "Move to Draft" : "Publish"}</Button>
                </>
        })
    }
    const updatePackageStatus = (status, package_seq) => {
        PackageService.updatePackageStatus(package_seq, props.listing_seq, status === 'I' ? 'P' : 'I', () => {
            setConfirmationPopup({ open: false })
            props.setRefreshList && props.setRefreshList(!props.refreshList)
        })
    }


    const openMakeDuplicateConfirmation = (package_seq, name, packageData) => {

        let duplicateName = 'Copy of ' + name;

        setConfirmationPopup({
            open: true,
            package_seq: package_seq,
            title: 'Make a Copy',
            // body: <Typography>Do you really want to duplicate the package?</Typography>,
            body:
                <>
                    <GreyLabel label='Enter new name' required />
                    <TextField defaultValue={duplicateName} onChange={(e) => duplicateName = e.target.value} fullWidth sx={{ maxWidth: '600px' }}></TextField>
                </>,
            buttons:
                <>
                    <Button variant="text" color="secondary" onClick={() => { setConfirmationPopup({ open: false }) }}>CANCEL</Button>
                    <Button variant="contained" color="primary" onClick={() => { duplicatePackage(package_seq, duplicateName) }}>DUPLICATE</Button>
                </>
        })
    }
    const duplicatePackage = (package_seq, duplicateName) => {

        PackageService.duplicatePackage(package_seq, duplicateName, () => {
            setConfirmationPopup({ open: false })
            props.setRefreshList && props.setRefreshList(!props.refreshList)
        })
    }


    const openDeleteConfirmation = (package_seq) => {
        setConfirmationPopup({
            open: true,
            package_seq: package_seq,
            title: 'Confirm the action',
            body: <Typography>Do you really want to delete the package?</Typography>,
            buttons:
                <>
                    <Button variant="contained" color="error" onClick={() => { deletePackage(package_seq) }}>DELETE</Button>
                    <Button variant="text" color="secondary" onClick={() => { setConfirmationPopup({ open: false }) }}>CANCEL</Button>
                </>
        })
    }

    const deletePackage = (package_seq) => {
        PackageService.deletePackage(package_seq, () => {
            setConfirmationPopup({ open: false })
            props.setRefreshList && props.setRefreshList(!props.refreshList)
        })
    }


    useEffect(() => {
        filterPackages(setPackageGrouped)
        if (location.pathname.includes('/property')) { // Added this to check which page is showing packagelist depending on that we use it direct to property or package page
            // console.log("true")
            setIsPropertyPage(true)
        } else {
            setIsPropertyPage(false)
            // console.log("false")
        }
    }, [packages, packageActivity])


    useEffect(() => {
        filterPackages(setPackageGroupedCount)
    }, [packages])


    return (
        <Box ref={sectionRef}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 3
                }}
            >
                <Typography variant="h5" fontWeight={600}>Packages</Typography>
                {/* <Select
                    value={packageActivity}
                    onChange={(e) => { setPackageActivty(e.target.value) }}
                    IconComponent={Icon.KeyboardArrowDownOutlined}
                    sx={{ width: '20ch' }}
                    size="small"
                >
                    <MenuItem value="A">All ({packages.length})</MenuItem>
                    <MenuItem value="H">Hunting ({extractDataFromArray(packageGroupedCount, ['H'], []).length})</MenuItem>
                    <MenuItem value="F">Fishing ({extractDataFromArray(packageGroupedCount, ['F'], []).length})</MenuItem>
                    <MenuItem value="BW">Bird Watching ({extractDataFromArray(packageGroupedCount, ['BW'], []).length})</MenuItem>
                    <MenuItem value="FR">Farm and Ranch ({extractDataFromArray(packageGroupedCount, ['FR'], []).length})</MenuItem>
                </Select> */}
                <Select
                    value={packageActivity}
                    onChange={(e) => { setPackageActivty(e.target.value) }}
                    IconComponent={Icon.KeyboardArrowDownOutlined}
                    sx={{ maxWidth: '20ch', width: '100%' }}
                    size="small"
                >
                    <MenuItem value="A">All ({packages.length})</MenuItem>
                    {packageOrder.map((activity) => {
                        const activityType = activity.type;
                        const itemCount = extractDataFromArray(packageGroupedCount, [activityType], []).length;

                        // Only render the MenuItem if the itemCount is greater than 0
                        if (itemCount > 0) {
                            return (
                                <MenuItem key={activityType} value={activityType}>
                                    {`${activity.label} (${itemCount})`}
                                </MenuItem>
                            );
                        }

                        return null; // Don't render the MenuItem if the itemCount is 0
                    })}
                </Select>

            </Box>
            <Divider sx={{ mt: 3, mb: 2 }} />
            {
                packageOrder.map((activity, i) => {
                    if (typeof packageGrouped[activity.type] !== "undefined") {
                        return (
                            <Box sx={{ mb: 3 }} key={"package_list_" + activity.type + "_" + i}>
                                <Typography variant="h6" sx={{ mb: 1, fontWeight: 'normal' }}>
                                    {activity.label}
                                </Typography>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2, sm: 2, md: 3, lg: 3 } }}>
                                    {
                                        packageGrouped[activity.type].map((packageData, index) => {
                                            // console.log("packageGrouped", packageData)
                                            let renderTitle = getActivityType(packages[index])
                                            let listing_seq = extractDataFromArray(packageData, ["listing_seq"], '')
                                            let package_seq = extractDataFromArray(packageData, ["package_seq"], '')
                                            return (
                                                <PackageCard
                                                    elevation={2}
                                                    key={"package_list_" + activity.type + "_" + i + "_" + index}
                                                    image={extractDataFromArray(packageData, ['package_json', 'media_library'], '')}
                                                    title={extractDataFromArray(packageData, ["package_title"], '')}
                                                    listing_seq={listing_seq}
                                                    package_seq={package_seq}
                                                    lat={extractDataFromArray(listingData, ["listing_json", 'location_info', "property_ltln", 0])}
                                                    long={extractDataFromArray(listingData, ["listing_json", 'location_info', "property_ltln", 1])}
                                                    address={`${extractDataFromArray(
                                                        listingData,
                                                        ["listing_json", "location_info", "property_area"],
                                                        ""
                                                    )} Acres, ${renderTitle} at `}
                                                    propertyName={`${extractDataFromArray(listingData, ['listing_json', 'property_details', 'name'], '')}`}
                                                    address2={` near ${extractDataFromArray(
                                                        listingData,
                                                        ["listing_json", "location_info", "nearest_town"],
                                                        ""
                                                    )}`}
                                                    isPropertyPage={isPropertyPage}
                                                    slug={extractDataFromArray(packageData, ["package_slug"], '')}
                                                    activity={extractDataFromArray(packageData, ["activity_type"], 'H')}
                                                    size={extractDataFromArray(listingData, ["listing_json", "location_info", "property_area"], '')}
                                                    cardType="package"
                                                    guest={extractDataFromArray(packageData, ["package_json", "min_guests"], '')}
                                                    days={extractDataFromArray(packageData, ["package_json", "min_days"], '')}
                                                    price={extractDataFromArray(packageData, ["package_json", "price_per_guest"], '')}
                                                    nearest_town={extractDataFromArray(packageData, ['listing_json', 'location_info', 'nearest_town'], '')}
                                                    rv={extractDataFromArray(packageData, ['listing_json', 'ground_rule', 'rv', 'available'], '')}
                                                    lodging={extractDataFromArray(packageData, ['listing_json', 'lodging_details', 'available'], '')}
                                                    showViewDetailButton={true}
                                                    status={extractDataFromArray(packageData, ['status'], '')}
                                                    showMoreOptions={true}
                                                    isPackageEditor={props.isPackageEditor}
                                                    handlePackageEdit={() => {
                                                        navigate(ROUTE_CREATE_ACCESS_PACKAGE + "?listingSeq=" + listing_seq + '&packageSeq=' + package_seq + '&edit=1')
                                                    }}
                                                    duplicatePackage={() => { console.log("here"); openMakeDuplicateConfirmation(extractDataFromArray(packageData, ['package_seq'], ''), extractDataFromArray(packageData, ['package_json', 'name'], ''), packageData) }}
                                                    deletePackage={() => { openDeleteConfirmation(extractDataFromArray(packageData, ['package_seq'], '')) }}
                                                    changeStatus={() => { openChangeStatusConfirmation(extractDataFromArray(packageData, ['package_seq'], ''), extractDataFromArray(packageData, ['status'], 'I')) }}
                                                    showEditButton={props.showEditButton}
                                                />
                                            )
                                        })
                                    }
                                </Box>
                            </Box>
                        )
                    }
                    return <div key={"package_list_" + activity.type + "_" + i}></div>
                })
            }
            <Dialog open={confirmationPopup.open}  >
                <Box >
                    <Box sx={{ p: 2.5 }}>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>{confirmationPopup.title}</Typography>
                    </Box>
                    <Divider />
                    <Box sx={{ p: 2.5 }}>
                        {confirmationPopup.body}
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'end', gap: 1, p: 2.5, width: '100%' }}>
                        {confirmationPopup.buttons}

                    </Box>
                </Box>
            </Dialog>
        </Box >
    )
}

export default PackageList;